import React, { useContext, useState } from 'react'
import { TicketStyles } from './Style'
import { Title as ScreenTitle } from 'components'
import { useParams } from 'react-router-dom'
import { Divider, TextareaAutosize } from '@mui/material'
import { thirdly2 } from 'styles/theme'
import { Button, Chip, UploadFile } from 'components/Form'
import { TicketContext } from './TicketContext'
import { timeAgo } from 'utils/formatter'
import { LightButton, Space } from 'styles/GlobalStyle'
import { StatusCell, StatusChip, ticketHooks } from '.'
import TicketMessage from './TicketMessage'

const Ticket = (props) => {
    const params = useParams()
    const { image, setImage, setMessage, message, ticket, ticketMessages, openMessageBox, setOpenMessageBox } = useContext(TicketContext)
    const createTicketMessageBtn = ticketHooks.useCreateTicketMessageBtn()
    const closeTicketBtn = ticketHooks.useCloseTicket()
    const toBeDevelopedTicketBtn = ticketHooks.useToBeDeveloped()
    const ticketDetails = ticketHooks.useTicketDetails()

    const { has_new_message, ticket_message_count, messageId, created_by_name, create_date, image_url, description, status, title } = ticket?.data || {}

    return (
        <TicketStyles>
            <ScreenTitle {...props} breadcrumbs={true}>
                <div className='bread-crumbs-title'>
                    <div>{">"}</div>
                    {" פניה מספר"}
                    {` #${params.ticketID}`}
                    <div className='status-chip'>
                        <StatusChip has_new_message={has_new_message} ticket_message_count={ticket_message_count} status={status} />
                    </div>
                </div>
            </ScreenTitle>

            <div className='ticket-content'>
                <div className='ticket-details'>
                    <div className='ticket-title'>{"סיכום פרטי הפניה"}</div>
                    <div className='ticket-detail-list'>
                        {ticketDetails.map((ticketDetail) =>
                            <React.Fragment>
                                <div className='ticket-detail-list-item'>
                                    <div className='ticket-detail-list-title'>{ticketDetail.label}</div>
                                    <div className='ticket-detail-list-content'>{ticketDetail.value}</div>
                                </div>
                                <Divider sx={{ borderColor: thirdly2 }} />
                            </React.Fragment>
                        )}
                    </div>
                    <div className='update-ticket-status'>
                        <Button {...closeTicketBtn} />
                        <Button {...toBeDevelopedTicketBtn} />
                    </div>
                </div>
                <div className='wrap-ticket-messages'>
                    <div className='ticket-title'>{title}</div>
                    <div className='wrap-ticket-messages1'>
                        <TicketMessage hideMenu content={description} written_by_name={created_by_name} create_date={create_date} image={image_url} />
                        <div className='ticket-messages'>
                            {ticketMessages.data?.map((ticketMessage) =>
                                <TicketMessage {...ticketMessage} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {status == "OPEN" &&
                <div className='wrap-message-box'>
                    <div className='message-box-and-button'>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={5}
                            maxRows={5}
                            value={message}
                            placeholder='מה יש לך להוסיף?'
                            onChange={({ target }) => setMessage(target.value)}
                        />
                        <div className='wrap-create-and-upload-file'>
                            <UploadFile className="image-field" input={{ value: image, onChange: setImage }} type="image" size="small" />
                            <div className='create-ticket-message'>
                                <LightButton variant="solid" {...createTicketMessageBtn} />
                            </div>
                        </div>
                    </div>
                </div>}
        </TicketStyles>
    )
}

export default Ticket